module.exports = __webpack_public_path__ + "static/media/company-dropdown-arrow.f79d355a.svg";